import { render, staticRenderFns } from "./BrandPopup.vue?vue&type=template&id=0ad87a86&scoped=true&"
import script from "./BrandPopup.vue?vue&type=script&lang=js&"
export * from "./BrandPopup.vue?vue&type=script&lang=js&"
import style0 from "./BrandPopup.vue?vue&type=style&index=0&id=0ad87a86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad87a86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ad87a86')) {
      api.createRecord('0ad87a86', component.options)
    } else {
      api.reload('0ad87a86', component.options)
    }
    module.hot.accept("./BrandPopup.vue?vue&type=template&id=0ad87a86&scoped=true&", function () {
      api.rerender('0ad87a86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/BrandPopup.vue"
export default component.exports